// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3dxjI","label":"Labeled_label__1VvAn","divider":"Labeled_divider__21fK1"};